import { calculateProductPriceValue, isEmpty } from './helper.js';

export const sendAddToCartTiktokEvent = product => {
	// if (!window.cookiesConsent.marketing) return;
	if (!window.ttq) return;

	if (isEmpty(product)) return;

	window.ttq.track('AddToCart', {
		content_id: product.id,
		content_type: 'product',
		content_name: product.nm,
		quantity: 1,
		price: calculateProductPriceValue(product),
		value: calculateProductPriceValue(product),
		currency: 'EUR'
	});
};

export const sendPurchaseTiktokEvent = (order, orderItems) => {
	// if (!window.cookiesConsent.marketing) return;
	if (!window.ttq) return;

	if (isEmpty(order)) return;

	const products = [];

	orderItems.map(item => {
		let product = {
			content_id: item.pid,
			content_type: 'product',
			content_name: item.nm,
			quantity: item.qty,
			price: item.upr,
			discount: item.dsc
		};

		products.push(product);
	});

	window.ttq.track('CompletePayment', {
		contents: products,
		value: order.gamt,
		currency: 'EUR'
	});
};

export const sendViewContentTiktokEvent = product => {
	// if (!window.cookiesConsent.marketing) return;
	if (!window.ttq) return;

	if (!product) return;

	window.ttq.track('ViewContent', {
		content_type: 'product',
		content_category: product.cnm?.split(',')[0],
		content_id: product.id,
		content_name: product.nm,
		price: calculateProductPriceValue(product),
		value: calculateProductPriceValue(product),
		currency: 'EUR'
	});
};
